module.exports = __webpack_public_path__ + "img/智能供应协同管理.25bf7be6.png";